

export default {
  SET_ITEMS(state, payload) {
    state.interventions = payload
  },

  SET_ITEMS_ARTISAN(state, payload) {
    state.interventionsByArtisan = payload
  },

  SET_ITEMS_HAS_INVOICE(state, payload) {
    state.interventionsHasInvoice = payload
  },

  SET_ITEMS_DOESNT_HAVE_INVOICE(state, payload) {
    state.interventionsDoesntHaveInvoice = payload
  },

  ADD_ITEM(state, payload) {
    state.interventions.push(payload)
  },

  UPDATE_ITEM(state, payload) {
    const ItemIndex = state.interventions.findIndex((p) => p.id == payload.id)
    Object.assign(state.interventions[ItemIndex], payload)
  },

  UPDATE_ITEM_ETAT(state, payload) {
    const ItemIndex = state.interventions.findIndex((p) => p.id == payload.id)
    Object.assign(state.interventions[ItemIndex], payload)
  },

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.interventions.findIndex((p) => p.id == itemId)
      state.interventions.splice(ItemIndex, 1)
  },

  SET_ITEMS_NBR_INTERVENTION(state, payload) {
    state.usersNbrsInterventions = payload
  },

  SET_ITEMS_HISTORIQUES_BY_INTERVENTION(state, payload) {
    state.historiquesByIntervention = payload
  },
}
